import { render, staticRenderFns } from "./DataProcessingDetails.vue?vue&type=template&id=aeda47fe&scoped=true"
import script from "./DataProcessingDetails.vue?vue&type=script&lang=js"
export * from "./DataProcessingDetails.vue?vue&type=script&lang=js"
import style0 from "./DataProcessingDetails.vue?vue&type=style&index=0&id=aeda47fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeda47fe",
  null
  
)

export default component.exports